import type { SrmSceneKey } from './data/types';

export interface SrmSeoTdk {
  title: string;
  description: string;
  keywords: string;
}

export const SRM_OVERVIEW_TDK: SrmSeoTdk = {
  title: 'AI SRM采购与供应商管理平台-端点科技',
  description:
    '端点AI SRM采购与供应商管理平台贯通需求、寻源、合同、履约、结算与供应商管理，以AI覆盖数智化集采、风险控制、物料治理等六大智慧采购场景，助力企业提升采购效率与合规管控能力。',
  keywords: 'AI SRM,智慧采购,供应商管理,采购数字化,寻源招标,采购合规,采购管理系统,端点科技'
};

export const SRM_SCENE_TDK: Record<SrmSceneKey, SrmSeoTdk> = {
  'collective-procurement': {
    title: '数智化集采-AI SRM-端点科技',
    description:
      '端点AI SRM数智化集采场景帮助企业从「各自为政」走向「统一协同」，建立「一个平台、两种模式」的采购治理模式：通用物资统一寻源、框架协议、按需下单，专业物资分散采购并受集团规则监督，释放规模议价能力。',
    keywords: '数智化集采,集中采购,集团采购,统一寻源,框架协议,采购治理,规模议价,端点科技'
  },
  'full-process': {
    title: '数智化全流程-AI SRM-端点科技',
    description:
      '端点AI SRM数智化全流程场景让采购从「只管招标」升级为「管好采购全链路」，贯通需求计划、寻源、合同框架、采购商城、订单、履约、结算与供应商协同，支撑业务在线协同与采购经营数据可视化。',
    keywords: '采购全流程,数智化采购,需求计划,寻源管理,合同管理,采购商城,履约结算,采购协同,端点科技'
  },
  'risk-control': {
    title: '智能风险控制-AI SRM-端点科技',
    description:
      '端点AI SRM智能风险控制场景推动采购从「制度管」升级为「制度+系统管」，通过职责分离、利益冲突申报、投标信息加密、评标全程透明、过程留痕与智能风险预警，让不合规操作「做不了」而非仅靠「不敢做」。',
    keywords: '采购风险控制,采购合规,职责分离,利益冲突申报,围串标识别,智能清标,辅助评标,内控闭环,端点科技'
  },
  'material-governance': {
    title: '智能物料治理-AI SRM-端点科技',
    description:
      '端点AI SRM智能物料治理场景应对品类繁杂难题，以品类管理体系、商城电商化采购体验与智能物料治理，推动分类合理、属性标准、描述规范、编码统一与一料一码，实现增量防控与存量治理并举。',
    keywords: '物料治理,品类管理,物料主数据,一料一码,物料标准化,商城化采购,存量治理,增量防控,端点科技'
  },
  'supplier-management': {
    title: '供应商智能管理-AI SRM-端点科技',
    description:
      '端点AI SRM供应商智能管理场景以供应商全生命周期与集团统一视角，实现「一商一档 + 全组织共用 + 绩效驱动」，统一准入标准、风险查验、360 画像与分级奖惩，共享红线与黑名单。',
    keywords: '供应商管理,供应商全生命周期,供应商准入,供应商绩效,供应商画像,供应商风险查验,黑名单管理,端点科技'
  },
  'ai-native': {
    title: 'AI 原生方式-AI SRM-端点科技',
    description:
      '端点AI SRM AI 原生方式场景以统一平台底座支撑分阶段平滑演进，通过读懂业务意图自动生成并适配应用，实现业务规格变、应用即变，减少硬编码与人工转译偏差，保留历史数据与既有能力。',
    keywords: 'AI原生,统一平台底座,平滑演进,业务规格驱动,AI应用生成,系统集成,低代码,端点科技'
  }
};
